// extracted by mini-css-extract-plugin
module.exports = {"container":"page_container__KznFg","no_content":"page_no_content__-_kP3"};